// M004-F0800 (WebUI #266 slice 2): the Statement view on statement.get. Pure rules, no I/O.
//
// The Ledger answers the WHOLE history of one customer, in ledger order. Each line carries balance_minor, the RUNNING balance the
// Ledger computed. This module never recomputes a balance: opening and closing are read from balance_minor, and a row shows the
// balance_minor the Ledger sent. Negative means a credit (shown "CR"). Dates are ISO YYYY-MM-DD strings, compared as strings.

// A period is { from, to }. null or undefined on a side means no bound on that side ("All" is { from: null, to: null }).
export function periodView(lines, { from = null, to = null } = {}) {
  const history = Array.isArray(lines) ? lines : [];
  const lowerBound = from ?? null;
  const upperBound = to ?? null;
  const inPeriod = (line) => (lowerBound === null || line.date >= lowerBound) && (upperBound === null || line.date <= upperBound);

  // opening: the balance_minor of the LAST line before `from`, or 0 when there is none.
  let opening_minor = 0;
  if (lowerBound !== null) {
    for (const line of history) {
      if (line.date < lowerBound) opening_minor = line.balance_minor;
    }
  }

  // closing: the balance_minor of the last line at or before `to`; the opening when there is none.
  let closing_minor = opening_minor;
  if (upperBound !== null) {
    for (const line of history) {
      if (line.date <= upperBound) closing_minor = line.balance_minor;
    }
  } else if (history.length > 0) {
    closing_minor = history[history.length - 1].balance_minor;
  }

  const rows = history.filter(inPeriod);
  return { opening_minor, closing_minor, rows };
}

// "£40.00 CR" for a credit, "£15.00" for a debit balance, "£0.00" for nil.
export function formatBalance(minor) {
  const pounds = Math.abs(minor) / 100;
  const text = `£${pounds.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  if (minor < 0) return `${text} CR`;
  return text;
}

// The amount of one line with its sign shown plainly: "+£100.00", "-£30.00", "£0.00".
export function formatAmount(minor) {
  const text = formatBalance(Math.abs(minor)).replace(/ CR$/, '');
  if (minor > 0) return `+${text}`;
  if (minor < 0) return `-${text}`;
  return text;
}

// The "This month" and "Last month" presets, relative to `today` (a Date, read in UTC). Returns ISO { from, to }.
export function monthPreset(kind, today = new Date()) {
  const offset = kind === 'last' ? -1 : 0;
  const year = today.getUTCFullYear();
  const month = today.getUTCMonth() + offset;
  const first = new Date(Date.UTC(year, month, 1));
  const last = new Date(Date.UTC(year, month + 1, 0));
  return { from: first.toISOString().slice(0, 10), to: last.toISOString().slice(0, 10) };
}
